import { render, staticRenderFns } from "./bank-transfer.vue?vue&type=template&id=bb6b29b8&"
import script from "./bank-transfer.js?vue&type=script&lang=js&"
export * from "./bank-transfer.js?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports